export const maxDurationMinutes = 600;
